import { useState, useEffect } from "react"
import { Grid, Icon, IconButton } from "@mui/material"
import { useDispatch, useSelector } from "react-redux";
import { Select } from "@gpstrackit/react-controls";
import { useIntl } from "react-intl";
//Components
import { SidePanel, Button, ToggleSwitch } from "@gpstrackit/react-controls";

import {
    searchEntityRequest,
    searchTagsRequest,
    clearRedux,
} from "Redux/actions";

import { HasPermission } from 'Core/security';
import { getNetworkTypes, getStatusOptions, getHardwareVersionOptions } from 'Core/data/Helpers';
import { set } from "lodash";

const AdvancedFilters = (props) => {
    const { openPanel, setOpenPanel, tableRef, manufacturer, setManufacturer, brand, setBrand, deviceModel, setDeviceModel, simProviderAccount, setSimProviderAccount, networkType, setNetworkType, status, setStatus, setTotal, installedOnly, setInstalledOnly, maintenanceWarnings, setMaintenanceWarnings, selectedTags, setSelectedTags, hardwareVersion, setHardwareVersion, autoCloseOnApply = false } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const VIDFLEET_NAME = 'VidFleet';

    //Redux States
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const loadingManufactuers = useSelector(state => state.generalRedux.manufacturersLoading);
    const deviceModels = useSelector(state => state.generalRedux.deviceModels);
    const loadingDeviceModels = useSelector(state => state.generalRedux.deviceModelsLoading);
    const simProviderAccounts = useSelector(state => state.generalRedux.simProviderAccounts);
    const loadingSimProviderAccounts = useSelector(state => state.generalRedux.simProviderAccountsLoading);
    const loadingDevices = useSelector(state => state.commonRedux.loadingDataView);
    const { loadingEntity, dealers } = useSelector(state => state.generalRedux);
    const user = useSelector(state => state.securityRedux.user);

    const tags = useSelector(state => state.generalRedux.tags);
    const loading = useSelector(state => state.generalRedux.tagLoading);

    const [conditions, setConditions] = useState(tableRef?.current?.conditions || []);

    const handleApply = () => {
        tableRef?.current?.getData({ newConditions: conditions });
        if (autoCloseOnApply) {
            setOpenPanel(false);
        }
    }

    useEffect(() => {
        openPanel && (!manufacturers || manufacturers?.length === 0) && dispatch(searchEntityRequest({ key: "manufacturers" }));
        openPanel && (!deviceModels || deviceModels?.length === 0) && dispatch(searchEntityRequest({ key: "deviceModels" }));
        openPanel && (!simProviderAccounts || simProviderAccounts?.length === 0) && dispatch(searchEntityRequest({ key: "simProviderAccounts" }));
        openPanel && (!dealers || dealers?.length === 0) && dispatch(searchEntityRequest({ key: "dealers" }))
        openPanel && dispatch(searchTagsRequest({ messages: messages }));
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([])
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={(manufacturer || hardwareVersion || deviceModel || simProviderAccount || networkType || status || brand || maintenanceWarnings || installedOnly || selectedTags?.length > 0) ? "side-panel-button" : "side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
                style={{ paddingBottom: '50px' }}
            >
                <Grid item xs={8}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['accounts_main_advanced_filters']}</label>
                </Grid>
                <Grid item xs={4} style={{ display: 'flex', justifyContent: 'end' }}>
                    <IconButton
                        onClick={() => {
                            setManufacturer(null);
                            setHardwareVersion(null);
                            setDeviceModel(null);
                            setSimProviderAccount(null);
                            setNetworkType(null);
                            setStatus(null);
                            setBrand(null);
                            setInstalledOnly(false);
                            setMaintenanceWarnings(false)
                            setSelectedTags([]);

                            const originalConditions = [...(tableRef?.current?.conditions || conditions)];
                            let currentConditions = [...originalConditions];

                            // remove manufacturer 
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'deviceModel_manufacturer_id');

                            // remove hardware version
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'unitConfig_hardwareVersion');

                            // remove device model
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'deviceModel_id');

                            // remove sim provider account
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'simCard_simProviderAccount_id');

                            // remove network type
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'network');

                            // remove status
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'status');

                            // remove dealer id
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'company_dealerId');

                            // remove installed only
                            currentConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'installed');

                            // remove maintenance warnings
                            currentConditions = currentConditions.filter((item) => item?.range && item?.range.fields && item?.range.fields[0] !== 'maintenanceWarnings');

                            let deleteTags = currentConditions.findIndex((item) => item.fields && item.fields[0] === 'tagIds');
                            deleteTags >= 0 && currentConditions.splice(deleteTags, 1);

                            // Tag-derived conditions (from SearchInput) carry a .tags property
                            const tagConditions = originalConditions.filter(item => item.tags);
                            if (tagConditions.length > 0) {
                                // SearchInput has tags → re-search keeping only those conditions
                                tableRef?.current?.getData({ newConditions: tagConditions, filters: { filterValidation: true } });
                                setConditions(tagConditions);
                            } else {
                                // No search tags → clear the grid without searching
                                tableRef?.current?.clearGrid();
                                setConditions([]);
                                setTotal(0);
                                dispatch(clearRedux("COMMON", { "units": {} }));
                            }

                        }}
                        size="large">
                        <Icon>delete</Icon>
                    </IconButton>
                </Grid>
                <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Button
                        className="btn btn-dark-blue btn-block"
                        onClick={(e) => {
                            e.preventDefault();
                            handleApply();
                        }}
                        disabled={loadingDevices}
                    >
                        {messages['devices_main_apply']}
                    </Button>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        HasPermission(user, "man") &&
                        <div>
                            <Select
                                id="manufactures"
                                label={messages['devices_main_manufacturer']}
                                value={manufacturers && manufacturers.length > 0 && manufacturers.find(x => x.id === +manufacturer)}
                                onChange={(manufacturer) => {
                                    setManufacturer(manufacturer ? manufacturer.id : null);
                                    setDeviceModel(null);
                                    setHardwareVersion(null);
                                    let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                    let newConditions = currentConditions
                                        .filter((item) => item.fields && item.fields[0] !== 'deviceModel_manufacturer_id')
                                        .filter((item) => item.fields && item.fields[0] !== 'deviceModel_id')
                                        .filter((item) => item.fields && item.fields[0] !== 'unitConfig_hardwareVersion');
                                    if (manufacturer) {
                                        newConditions.push({ fields: ["deviceModel_manufacturer_id"], terms: [`${manufacturer.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                options={manufacturers || []}
                                textField="name"
                                valueField="id"
                                menuPlacement="auto"
                                isClearable
                                loading={loadingManufactuers}
                                placeholder={messages['select']}
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        HasPermission(user, "man") && (manufacturers || []).find(x => x.id === +manufacturer)?.name === VIDFLEET_NAME &&
                        <div>
                            <Select
                                id="hardware_version"
                                label={messages['devices_main_hardware_version']}
                                value={getHardwareVersionOptions().find(x => x.id === hardwareVersion)}
                                onChange={(hardwareVersionChange) => {
                                    setHardwareVersion(hardwareVersionChange ? hardwareVersionChange.id : null);
                                    let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                    let newConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'unitConfig_hardwareVersion');
                                    if (hardwareVersionChange) {
                                        newConditions.push({ fields: ["unitConfig_hardwareVersion"], terms: [`${hardwareVersionChange.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                options={getHardwareVersionOptions()}
                                textField="label"
                                valueField="id"
                                menuPlacement="auto"
                                isClearable
                                //loading={loadingManufactuers}
                                placeholder={messages['select']}
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        HasPermission(user, "devmod") &&
                        <div>
                            <Select
                                id="deviceModels"
                                label={messages['devices_main_device_model']}
                                value={manufacturer && deviceModels && deviceModels.length > 0 && deviceModels.find(x => x.id === +deviceModel)}
                                onChange={(deviceModel) => {
                                    setDeviceModel(deviceModel ? deviceModel.id : null);
                                    let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                    let newConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'deviceModel_id');

                                    if (deviceModel) {
                                        newConditions.push({ fields: ["deviceModel_id"], terms: [`${deviceModel.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                options={manufacturer ? deviceModels && deviceModels.filter(x => x.manufacturerId === +manufacturer) : []}
                                textField="name"
                                valueField="id"
                                menuPlacement="auto"
                                isClearable
                                loading={loadingDeviceModels}
                                placeholder={messages['select']}
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <div>
                        <Select
                            id="brand"
                            label={messages['devices_main_brand']}
                            value={dealers && dealers.length > 0 && dealers.find(x => x.id === +brand)}
                            onChange={(value) => {
                                setBrand(value ? value.id : null);
                                let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                let newConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'company_dealerId');
                                if (value) {
                                    newConditions.push({ fields: ["company_dealerId"], terms: [`${value.id}`], exact: true, conditionOperator: "AND" })
                                }
                                tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                setConditions(newConditions);
                            }}
                            options={dealers || []}
                            textField="name"
                            valueField="id"
                            menuPlacement="auto"
                            isClearable
                            loading={loadingEntity}
                            placeholder={messages['select']}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    <div>
                        <Select
                            id="simProviderAccounts"
                            label={messages['devices_main_sim_provider_account']}
                            value={simProviderAccounts && simProviderAccounts.length > 0 && simProviderAccounts.find(x => x.id === +simProviderAccount)}
                            onChange={(simProviderAccount) => {
                                setSimProviderAccount(simProviderAccount ? simProviderAccount.id : null);
                                let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                let newConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'simCard_simProviderAccount_id');

                                if (simProviderAccount) {
                                    newConditions.push({ fields: ["simCard_simProviderAccount_id"], terms: [`${simProviderAccount.id}`], exact: true, conditionOperator: "AND" })
                                }
                                tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                setConditions(newConditions);
                            }}
                            options={simProviderAccounts || []}
                            getOptionLabel={e => `${e?.simProvider?.name || ''}${e.name ? ` - ${e.name}` : ''}`}
                            getOptionValue={e => e.id}
                            textField="name"
                            valueField="id"
                            menuPlacement="auto"
                            isClearable
                            loading={loadingSimProviderAccounts}
                            placeholder={messages['select']}
                        />
                    </div>
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        <div>
                            <Select
                                id="change-status-id"
                                valueField="id"
                                textField="label"
                                value={getStatusOptions(messages).find(x => x.id === +status)}
                                label={messages['account_change_status_label']}
                                placeholder={messages['account_change_status_label']}
                                options={getStatusOptions(messages) || []}
                                onChange={(status) => {
                                    setStatus(status ? status.id : null);
                                    let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                    let newConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'status');

                                    if (status) {
                                        newConditions.push({ fields: ["status"], terms: [`${status.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                requiredMessage={messages['required_field']}
                                isClearable
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10 }}>
                    {
                        <div>
                            <Select
                                id="networkTypes"
                                label={messages['devices_main_network_type']}
                                value={getNetworkTypes().find(x => x.id === networkType)}
                                onChange={(networkType) => {
                                    setNetworkType(networkType ? networkType.id : null);
                                    let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                                    let newConditions = currentConditions.filter((item) => item.fields && item.fields[0] !== 'network');

                                    if (networkType) {
                                        newConditions.push({ fields: ["network"], terms: [`${networkType.id}`], exact: true, conditionOperator: "AND" })
                                    }
                                    tableRef?.current?.getData({ newConditions, filters: { filterValidation: false } });
                                    setConditions(newConditions);
                                }}
                                options={getNetworkTypes() || []}
                                textField="name"
                                valueField="id"
                                menuPlacement="auto"
                                isClearable
                                placeholder={messages['select']}
                            />
                        </div>
                    }
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, marginBottom: 5 }}>
                    <Select
                        id="tags-selector"
                        label={messages['accounts_main_tags']}
                        value={selectedTags?.length ? tags.filter((item) => selectedTags.find(x => x === item.id)) : []}
                        onChange={(item = []) => {

                            let currentConditions = [...(tableRef?.current?.conditions || conditions)];

                            // Remove existing tagIds condition using filter (no mutation)
                            let newConditions = currentConditions.filter((item) => !(item.fields && item.fields[0] === 'tagIds'));
                            let itemsTags = []
                            if (item && item.length > 0 && item.find(x => x.id === -1)) 
                                itemsTags = tags.filter(x => x.id === -1);
                             else
                                itemsTags = item;

                            setSelectedTags(itemsTags?.map(x => x.id))
                            if (itemsTags && itemsTags.length > 0) newConditions.push({ fields: ["tagIds"], terms: itemsTags.map(x => x.id), exact: true, conditionOperator: "AND" })

                            setConditions(newConditions);
                        }}
                        options={tags}
                        textField="label"
                        valueField="id"
                        loading={loading}
                        isClearable
                        placeholder={messages['select']}
                        multiple
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, display: 'grid' }}>
                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['devices_main_installed_only']}</label>
                    <ToggleSwitch
                        id="installed_only"
                        medium
                        blueToggle
                        optionLabels={[messages['common_yes'], messages['common_no']]}
                        checked={installedOnly}
                        onChange={(checked) => {
                            setInstalledOnly(checked);
                            let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                            let newConditions;
                            if (checked) {
                                newConditions = [...currentConditions, { fields: ["installed"], terms: ["1"], exact: true, conditionOperator: "AND" }];
                            } else {
                                newConditions = currentConditions.filter((item) => !(item.fields && item.fields[0] === 'installed'));
                            }
                            setConditions(newConditions);
                        }}
                    />
                </Grid>
                <Grid item xs={12} style={{ textAlign: 'left', marginTop: 10, display: 'grid' }}>
                    <label style={{ marginBottom: 5 }} className="input-normal-label">{messages['devices_main_maintenance_warnings_label']}</label>
                    <ToggleSwitch
                        id="maintenance_warnings_only"
                        medium
                        blueToggle
                        optionLabels={[messages['common_yes'], messages['common_no']]}
                        checked={maintenanceWarnings}
                        onChange={(checked) => {
                            setMaintenanceWarnings(checked);
                            let currentConditions = [...(tableRef?.current?.conditions || conditions)];
                            let newConditions;
                            if (checked) {
                                newConditions = [...currentConditions, { range: { fields: ["maintenanceWarnings"], GTENumber: "1" } }];
                            } else {
                                newConditions = currentConditions.filter((item) => !(item?.range && item?.range.fields && item?.range.fields[0] === 'maintenanceWarnings'));
                            }
                            setConditions(newConditions);
                        }}
                    />
                </Grid>

            </Grid>
        </SidePanel>
    );
}
export default AdvancedFilters